import { PropTypes } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
const DetergentModalDialog = (props) => {
  const {
    children,
    title,
    isOpen,
    close,
    onReady,
    className,
    disabled,
    showFooter,
    onReadyParams,
  } = props;
  const onReadyWithParams = () => {
    onReady(...onReadyParams);
  };
  const intl = useIntl();
  return (
    <Modal isOpen={isOpen} toggle={close} className={className} centered>
      <ModalHeader className="custom-modal-title" toggle={close}>
        {title}
      </ModalHeader>
      <ModalBody data-testid="modal">{children}</ModalBody>
      {showFooter && (
        <ModalFooter className="detergent-modal-footer">
          {onReady && !onReadyParams ? (
            <Button
              className="button confirm"
              color="primary"
              onClick={onReady}
              disabled={disabled}
            >
              {intl.formatMessage({ id: 'saveSettings' })}
            </Button>
          ) : onReady && onReadyParams ? (
            <Button
              className="button confirm"
              color="primary"
              onClick={onReadyWithParams}
              disabled={disabled}
            >
              {intl.formatMessage({ id: 'saveSettings' })}
            </Button>
          ) : null}
        </ModalFooter>
      )}
    </Modal>
  );
};
DetergentModalDialog.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  onReady: PropTypes.func,
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  showFooter: PropTypes.bool,
  onReadyParams: PropTypes.arrayOf(PropTypes.any),
};
DetergentModalDialog.defaultProps = {
  showFooter: true,
};
export default DetergentModalDialog;
